import { COMPANY } from "../data/company";

// Construye un enlace de WhatsApp con un mensaje pre-cargado en español.
export function whatsappLink(message) {
  const text = encodeURIComponent(
    message || "Hola, me gustaría solicitar más información sobre sus productos."
  );
  return `https://wa.me/${COMPANY.phoneRaw}?text=${text}`;
}

export function productWhatsappLink(product) {
  const msg = `Hola, me gustaría solicitar información sobre el producto ${product.code} – ${product.name}.`;
  return whatsappLink(msg);
}

export const generalWhatsappLink = () =>
  whatsappLink(
    "Hola, me comunico desde la web de Manfredi Weber. Me gustaría hacer una consulta."
  );
